import React from "react"
import {createTheme} from '@mui/material/styles';
const theme = createTheme({
    palette: {
        type: 'light',
        background: {
            default: 'var(--background-color)'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1280,
            xl: 1536,
        },
    },
    components: {
        MuiChip: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: '#303543',
                    color: 'white'
                },
                colorSecondary: {
                    backgroundColor: '#008eba',
                    color: 'white'
                },
            },
        },
        MuiOutlinedInput:{
            styleOverrides:{
                root:{
                    // "& .MuiOutlinedInput-notchedOutline":{
                    //     borderColor:"black",
                    //     borderWidth:"1px",
                    // },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":{
                        borderColor:"var(--brand-color)",
                        borderWidth:"2px",
                    },
                    "&.Mui-error .MuiOutlinedInput-notchedOutline":{
                        borderColor:"red",
                        borderWidth:"1px",
                    },
                }
            }
        }
    },
});

export default theme;